// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3v3bH","inner":"Form_inner__2OtWB","range":"Form_range__1hXdr","name":"Form_name__318Ed","actions":"Form_actions__33cpE"};